import moment from "moment";
import { WEB_ACTION } from "./actions";
import { IData } from "./common";

const DATA_COUNT = 100;
const COLLECTION_NAME = "HIS1";

interface IHourlySentimentData {
  index: IData[];
  sentiment: IData[];
  momentum: IData[];
  requested: boolean;
  loaded: boolean;
}

const initialState: IHourlySentimentData = {
  momentum: [],
  sentiment: [],
  index: [],
  requested: false,
  loaded: false,
};

export function loadHourlySentiment(firebase: any) {
  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.HourlySentiment.requested) return;
    dispatch({
      type: WEB_ACTION.HOURLY_SENTIMENT,
      payload: {
        requested: true,
        loaded: false,
        momentum: [],
        index: [],
        sentiment: [],
      },
    });
    firebase
      .firestore()
      .collection(COLLECTION_NAME)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        var sentimentData: Object[] = [];
        var indexData: Object[] = [];
        var momentumData: Object[] = [];

        querySnapshot.forEach(function (doc: any) {
          const dateVal = moment
            .unix(doc.data().dateTime.seconds)
            .format("YYYY/MM/DD HH:mm");
          sentimentData.push({
            name: "sentiment",
            value: [dateVal, doc.data().sentiment],
            date: doc.data().dateTime.seconds,
          });
          momentumData.push({
            name: "momentum",
            value: [dateVal, doc.data().momentum],
            date: doc.data().dateTime.seconds,
          });

          indexData.push({
            name: "index",
            value: [dateVal, doc.data().index_value],
            date: doc.data().dateTime.seconds,
          });
        });
        indexData = indexData.reverse();
        momentumData = momentumData.reverse();
        sentimentData = sentimentData.reverse();
        dispatch({
          type: WEB_ACTION.HOURLY_SENTIMENT,
          payload: {
            index: indexData,
            momentum: momentumData,
            sentiment: sentimentData,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function HourlySentiment(state = initialState, action: any) {
  switch (action.type) {
    case WEB_ACTION.HOURLY_SENTIMENT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const hourlySentimentSelector = (state: any) => state.HourlySentiment;
